<template>
  <div class="experiment_title">    
      <div class='pb-0'>
          <h5 v-if="$route.name =='experiment'" class='p-3 m-0 pb-0 '>{{ show_experiment_name }} (Room {{ parseInt($cookies.get("equipment_id").slice(-1)) + 1 }})</h5>
          <h5 v-else-if="$route.params.equipment_name" class='p-3 m-0 pb-0 '>{{ show_experiment_name }} (Room {{ parseInt($route.params.equipment_name[4]) + 1 }})</h5>
          <h5 v-else class='p-3 m-0 pb-0 '>{{ show_experiment_name }}</h5>
      </div>
  </div>
</template>

<script>
import { Experiment_APIService } from "@/services/Experiment_APIService";
const apiService = new Experiment_APIService(process.env.VUE_APP_BASE_URL);
export default {
  name: "ExperimentTitle",  
  data: function () {
    return {
      show_experiment_name: this.$route.params.experiment_name,
    };
  },
  mounted: function () {
    this.labelExperiment(this.show_experiment_name);
  },
  methods: {
    labelExperiment: function (name) {
      switch(name){
        case 'photo_electric':
            this.show_experiment_name = 'Photo Electric';
            break;
        case "interference":
            this.show_experiment_name = "Interference";
            break;
        case "visible_spectrum":
            this.show_experiment_name = "Visible Spectrum";
            break;
        case "emission_spectrum":
            this.show_experiment_name = "Emission Spectrum";
            break;
        case "apparent_depth":
            this.show_experiment_name = "Apparent Depth";
            break;
        case "bacteria_growth":
            this.show_experiment_name = "Bacteria Growth";
            break;
        case "em_induction":
            this.show_experiment_name = "EM Induction";
            break;
        case "green_house":
            this.show_experiment_name = "Green House";
            break;
        case "photo_electric":
            this.show_experiment_name = "Photo Electric";
            break;
        case "radiation":
            this.show_experiment_name = "Radiation";
            break;
        case "titration":
            this.show_experiment_name = "Titration";
            break;
        case "ultrasound":
            this.show_experiment_name = "Ultrasound";
            break;
        case "respiration":
            this.show_experiment_name = "Respiration";
            break;
        case "photosynthesis":
            this.show_experiment_name = "Photosynthesis";
            break;
        case "identify_unknown_anion":
            this.show_experiment_name = "Identify Unknown Anion";
            break;
        case "kinetic_rate":
            this.show_experiment_name = "Kinetic Rate";
            break;
        case "spectrophotometry":
            this.show_experiment_name = "Spectrophotometry";
            break;
        case "iodine_test":
            this.show_experiment_name = "Iodine Test";
            break;
        case "tensile_test":
            this.show_experiment_name = "Tensile Test";
            break;
        case "new_interference":
            this.show_experiment_name = "New Interference";
            break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>